if (!customElements.get('brand-tab-select')) {
  class BrandTabSelect extends HTMLElement {
    constructor() {
      super();
      this.btn = this.querySelector('.brand-tab-select__btn');
      this.panel = this.querySelector('.brand-tab-select__panel');
      this.tabs = this.querySelectorAll('.brand-tabs__tab');
      this.tabPanels = this.querySelectorAll('.brand-tabs__panel');
      this.selectedUrl = null;
      this.isOpen = false;

      this.btn.addEventListener('mousedown', this.handleBtnMousedown.bind(this));
      this.addEventListener('click', this.handleClick.bind(this));
      this.outsideClickHandler = this.handleOutsideClick.bind(this);
    }

    handleBtnMousedown(evt) {
      if (evt.button !== 0) return;
      evt.preventDefault();
      this.isOpen ? this.closePanel() : this.openPanel();
    }

    openPanel() {
      this.panel.hidden = false;
      this.isOpen = true;
      this.btn.setAttribute('aria-expanded', 'true');
      setTimeout(() => document.addEventListener('click', this.outsideClickHandler));
    }

    closePanel() {
      this.panel.hidden = true;
      this.isOpen = false;
      this.btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this.outsideClickHandler);
    }

    handleOutsideClick(evt) {
      if (!this.contains(evt.target)) {
        this.closePanel();
      }
    }

    handleClick(evt) {
      // Tab switch
      const tab = evt.target.closest('.brand-tabs__tab');
      if (tab) {
        this.switchTab(tab.dataset.tab);
        return;
      }

      // Sort toggle
      const sortBtn = evt.target.closest('.js-sort-toggle');
      if (sortBtn) {
        this.toggleSort(sortBtn);
        return;
      }

      // Brand selection
      const brandEl = evt.target.closest('.js-brand');
      if (brandEl) {
        this.selectBrand(brandEl);
      }
    }

    switchTab(handle) {
      this.tabs.forEach((t) => {
        const active = t.dataset.tab === handle;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', String(active));
      });
      this.tabPanels.forEach((p) => {
        p.classList.toggle('is-active', p.dataset.tab === handle);
      });
    }

    toggleSort(btn) {
      const tabPanel = btn.closest('.brand-tabs__panel');
      const list = tabPanel.querySelector('.js-alpha-list');
      const isAsc = btn.dataset.dir === 'asc';

      btn.dataset.dir = isAsc ? 'desc' : 'asc';
      btn.textContent = isAsc ? 'Sort: Z–A' : 'Sort: A–Z';

      const groups = Array.from(list.querySelectorAll('.brand-tabs__alpha-group'));
      groups.reverse().forEach((g) => list.appendChild(g));
    }

    selectBrand(el) {
      // Highlight in both grid and alpha list
      const value = el.dataset.value;
      this.querySelectorAll('.js-brand').forEach((b) => b.classList.remove('is-selected'));
      this.querySelectorAll(`.js-brand[data-value="${CSS.escape(value)}"]`).forEach((b) => b.classList.add('is-selected'));

      // Update trigger button label
      const label = this.btn.querySelector('span');
      label.textContent = el.dataset.label || value;

      this.selectedUrl = el.dataset.url;
      this.selectedGid = el.dataset.gid || null;

      this.dispatchEvent(
        new CustomEvent('change', {
          bubbles: true,
          detail: { selectedValue: value, selectedGid: this.selectedGid }
        })
      );

      this.closest('brand-tab-select').classList.add('quick-nav__brand--has-value')

      const target = this.closest('.section') || this.closest('quick-nav') || this;
      const targetTop = target.getBoundingClientRect().top + window.scrollY;

      this.closePanel();

      // setTimeout(() => {
      //   window.scrollTo({ top: targetTop, behavior: 'smooth' });
      // }, 50);
    }
  }

  customElements.define('brand-tab-select', BrandTabSelect);
}
